import React from 'react';
import { IHomeNavigation, HomeNavigationType } from '../../../../services/types';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

interface IProps {
  data: IHomeNavigation[];
}

const useStyles = makeStyles((theme: Theme) => ({
  wrap: {
    height: 180,
  },

  item: {
    width: 160,
    height: 80,
    backgroundColor: `${theme.palette.primary.main}60`,
    borderRadius: 5,
    color: '#fff',
    margin: theme.spacing(0.5),
    padding: 12,
    fontFamily: 'Poppins',
  },
}));

const HomeNavigation = (props: IProps): JSX.Element => {
  const { data } = props;
  const classes = useStyles();

  const getContent = (navigation: IHomeNavigation) => {
    if (navigation.type === HomeNavigationType.Genre || navigation.type === HomeNavigationType.Theme) {
      return navigation.value.title;
    }

    if (navigation.type === HomeNavigationType.NewlyAdded) {
      return 'Newly Added';
    }

    if (navigation.type === HomeNavigationType.FreeReads) {
      return 'Free Reads';
    }
  };

  return (
    <Grid container direction="column" className={classes.wrap} alignContent={'flex-start'}>
      {data.map((navigation, i) => (
        <Grid item key={i} className={classes.item}>
          <Typography variant="h6">{getContent(navigation)}</Typography>
        </Grid>
      ))}
    </Grid>
  );
};

export default HomeNavigation;
